new Vue({
  delimiters: ['[[', ']]'],
  el: '#app_home'
});

$(document).ready(function () {
  var journalSection = document.querySelector('.brogan-journal');

  if (journalSection) {
    var journalGroups = journalSection.querySelectorAll('.brogan-journal__group');
    var journalPrimaryGroup = journalGroups[0];
    var journalCloneGroup = journalGroups[1];
    var journalUrl = new URL('https://blog.brogan.com.br/wp-json/wp/v2/posts');

    journalUrl.searchParams.set('per_page', '10');
    journalUrl.searchParams.set('page', '1');
    journalUrl.searchParams.set('_embed', 'true');

    function getJournalText(markup) {
      var parsedMarkup = new DOMParser().parseFromString(markup || '', 'text/html');
      return (parsedMarkup.body.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function getJournalPostImage(post) {
      var media = post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0];
      var sizes = media && media.media_details && media.media_details.sizes;
      var preferredSize = sizes && (sizes['post-thumbnail'] || sizes['brogan-card'] || sizes.large || sizes.medium_large);

      if (media && ((preferredSize && preferredSize.source_url) || media.source_url)) {
        return {
          src: preferredSize && preferredSize.source_url ? preferredSize.source_url : media.source_url,
          alt: media.alt_text || getJournalText(post.title && post.title.rendered)
        };
      }

      var contentMarkup = new DOMParser().parseFromString(post.content && post.content.rendered || '', 'text/html');
      var contentImage = contentMarkup.querySelector('img[src]');

      if (!contentImage) return null;

      return {
        src: contentImage.src,
        alt: contentImage.alt || getJournalText(post.title && post.title.rendered)
      };
    }

    function getJournalCategory(post) {
      var terms = post._embedded && post._embedded['wp:term'];
      var categories = terms && terms[0] ? terms[0] : [];
      var category = categories.find(function (term) {
        return term.name && term.name.toLowerCase() !== 'blog';
      }) || categories[0];

      return category ? category.name : '';
    }

    function createJournalCard(post, imageData) {
      var title = getJournalText(post.title && post.title.rendered);
      var article = document.createElement('article');
      var link = document.createElement('a');
      var figure = document.createElement('figure');
      var image = document.createElement('img');
      var category = getJournalCategory(post);

      article.className = 'brogan-journal__card';
      link.className = 'hidden-link';
      link.href = post.link;
      link.setAttribute('aria-label', title ? 'Leia: ' + title : 'Leia no The Brogan Journal');
      link.setAttribute('target', '_blank');
      figure.className = 'brogan-journal__media';
      image.src = imageData.src;
      image.alt = imageData.alt || title;
      image.loading = 'lazy';

      article.appendChild(link);
      figure.appendChild(image);
      article.appendChild(figure);

      var categoryLabel = document.createElement('span');
      categoryLabel.className = 'brogan-journal__category';
      categoryLabel.textContent = category;
      article.appendChild(categoryLabel);

      var heading = document.createElement('h3');
      heading.textContent = title;
      article.appendChild(heading);

      return article;
    }

    fetch(journalUrl.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('Erro HTTP: ' + response.status);
        return response.json();
      })
      .then(function (posts) {
        if (!Array.isArray(posts) || !journalPrimaryGroup || !journalCloneGroup) return;

        var journalCards = [];

        posts.forEach(function (post) {
          var imageData = getJournalPostImage(post);
          if (post.status !== 'publish' || !post.link || !imageData || !imageData.src) return;
          journalCards.push(createJournalCard(post, imageData));
        });

        if (!journalCards.length) {
          journalSection.setAttribute('aria-busy', 'false');
          return;
        }

        journalPrimaryGroup.innerHTML = '';
        journalCloneGroup.innerHTML = '';
        journalCards.forEach(function (card) {
          journalPrimaryGroup.appendChild(card);
        });

        Array.from(journalPrimaryGroup.children).forEach(function (card) {
          journalCloneGroup.appendChild(card.cloneNode(true));
        });
        journalCloneGroup.querySelectorAll('a').forEach(function (link) {
          link.setAttribute('tabindex', '-1');
          link.setAttribute('aria-hidden', 'true');
        });
        journalCloneGroup.querySelectorAll('img').forEach(function (image) {
          image.alt = '';
        });

        journalSection.classList.add('is-loaded');
        journalSection.setAttribute('aria-busy', 'false');
      })
      .catch(function (error) {
        journalSection.setAttribute('aria-busy', 'false');
        console.error('Não foi possível buscar os posts do The Brogan Journal:', error);
      });
  }

  var bannerHome = $('.banner-home');

  if (bannerHome.length) {
    if (bannerHome.children('.banner-home__slide').length > 1) {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      bannerHome.on('init', function () {
        bannerHome.css({ visibility: 'visible', opacity: '1' });
      });

      bannerHome.slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: true,
        autoplay: !reduceMotion,
        autoplaySpeed: 6500,
        dots: false,
        fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: reduceMotion ? 0 : 1100,
        cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)'
      });
    } else {
      bannerHome.css({ visibility: 'visible', opacity: '1' });
    }
  }

  var featuredBanners = Array.from(document.querySelectorAll('.brogan-featured__banner'));

  if (featuredBanners.length) {
    var featuredParallaxTicking = false;
    var featuredParallaxDesktop = window.matchMedia('(min-width: 992px)');
    var featuredParallaxReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function updateFeaturedParallax() {
      featuredParallaxTicking = false;

      featuredBanners.forEach(function (banner) {
        var content = banner.querySelector('.brogan-featured__banner-content');

        if (!content) return;

        if (!featuredParallaxDesktop.matches || featuredParallaxReducedMotion.matches) {
          content.style.transform = '';
          return;
        }

        var bannerRect = banner.getBoundingClientRect();
        var padding = 24;
        var anchor = window.innerHeight * 0.5;
        var maximumPosition = Math.max(padding, bannerRect.height - content.offsetHeight - padding);
        var position = Math.max(padding, Math.min(maximumPosition, anchor - bannerRect.top));

        content.style.transform = 'translateY(' + position.toFixed(1) + 'px)';
      });
    }

    function requestFeaturedParallaxUpdate() {
      if (featuredParallaxTicking) return;

      featuredParallaxTicking = true;
      window.requestAnimationFrame(updateFeaturedParallax);
    }

    window.addEventListener('scroll', requestFeaturedParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestFeaturedParallaxUpdate);
    updateFeaturedParallax();
  }

  document.querySelectorAll('.showcase-conveyor__viewport').forEach(function (viewport) {
    var list = viewport.querySelector('.product_list');

    if (!list || list.children.length < 2) return;

    var animationFrame = null;
    var lastTime = null;
    var conveyorOffset = 0;
    var isPaused = false;
    var isVisible = !('IntersectionObserver' in window);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileConveyor = window.matchMedia('(max-width: 991px)');
    var productPassDuration = 25000;

    function canAnimateConveyor() {
      return isVisible && !isPaused && !reducedMotion.matches && !mobileConveyor.matches;
    }

    function stopConveyor() {
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
      lastTime = null;
    }

    function requestConveyorFrame() {
      if (!canAnimateConveyor() || animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(animateConveyor);
    }

    function getFirstProductMetrics() {
      var firstProduct = list.firstElementChild;

      if (!firstProduct) return null;

      var listStyle = window.getComputedStyle(list);
      var productRect = firstProduct.getBoundingClientRect();
      var gap = parseFloat(listStyle.columnGap || listStyle.gap) || 0;

      return {
        element: firstProduct,
        width: productRect.width + gap
      };
    }

    function recycleFirstProduct(productMetrics) {
      if (conveyorOffset < productMetrics.width) return;

      conveyorOffset -= productMetrics.width;
      list.appendChild(productMetrics.element);
    }

    function animateConveyor(time) {
      animationFrame = null;

      if (!canAnimateConveyor()) return;
      if (lastTime === null) lastTime = time;

      var elapsed = Math.min(time - lastTime, 40);
      var productMetrics = getFirstProductMetrics();

      if (productMetrics) {
        conveyorOffset += elapsed * (productMetrics.width / productPassDuration);
        recycleFirstProduct(productMetrics);
        list.style.transform = 'translate3d(' + (-conveyorOffset).toFixed(3) + 'px, 0, 0)';
      }

      lastTime = time;
      requestConveyorFrame();
    }

    function pauseConveyor() {
      isPaused = true;
      stopConveyor();
    }

    function resumeConveyor(event) {
      if (event && event.type === 'focusout' && viewport.contains(event.relatedTarget)) return;
      isPaused = false;
      requestConveyorFrame();
    }

    viewport.addEventListener('mouseenter', pauseConveyor);
    viewport.addEventListener('mouseleave', resumeConveyor);
    viewport.addEventListener('focusin', pauseConveyor);
    viewport.addEventListener('focusout', resumeConveyor);
    viewport.addEventListener('touchstart', pauseConveyor, { passive: true });
    viewport.addEventListener('touchend', resumeConveyor, { passive: true });

    if ('IntersectionObserver' in window) {
      var conveyorObserver = new IntersectionObserver(function (entries) {
        isVisible = entries[0].isIntersecting;

        if (isVisible) requestConveyorFrame();
        else stopConveyor();
      });

      conveyorObserver.observe(viewport);
    }

    var handleConveyorMotionChange = function () {
      if (canAnimateConveyor()) requestConveyorFrame();
      else stopConveyor();
    };

    var handleConveyorLayoutChange = function () {
      if (mobileConveyor.matches) {
        stopConveyor();
        conveyorOffset = 0;
        list.style.transform = '';
      } else {
        requestConveyorFrame();
      }
    };

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleConveyorMotionChange);
    } else {
      reducedMotion.addListener(handleConveyorMotionChange);
    }

    if (mobileConveyor.addEventListener) {
      mobileConveyor.addEventListener('change', handleConveyorLayoutChange);
    } else {
      mobileConveyor.addListener(handleConveyorLayoutChange);
    }

    requestConveyorFrame();
  });

});
